export default __webpack_public_path__ + "b594f2ae5ef4c7cc24c046067dd89530.svg";